import type { FaireProductEntity } from "../../entity_types/product";

export const p_w4bwg8e5qe: FaireProductEntity = {
  token: "p_w4bwg8e5qe",
  type: "product",
  name: "Super Duper Sugar Squisher Toy- Mushroom",
  brandToken: "b_1785c86e",
  brandName: "Top Trenz Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/0b0b52de574ea7a3e89e0df034f4cd281a7a80aab3263dda5dbc52d15026e6f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ff7c18b50678248700ebc09e0d5acb0f79b68889a709eb3788cddc5907d1b48.jpeg",
    "https://cdn.faire.com/fastly/dd4d437aa5a1a9e826968d9f020a265ae8d4a668830775ff5b5c7d56cb6fe997.jpeg",
    "https://cdn.faire.com/fastly/d9e2d5152744d1db60ece6f9029e29068f94bae5be0b382cc4a71fd63029d844.jpeg",
    "https://cdn.faire.com/fastly/3d3ac5ce152c5eaad464191aac0a2c6008f0de5b7b876370c11bbd89f6a0149c.jpeg",
    "https://cdn.faire.com/fastly/b8700a93a4684516ba764f64a65676bb210f2720e0f8dbacfc0c0bd7133672ac.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "Meet the groovy Super Duper Sugar Squisher mushroom—a double sensory treat! With a soft, squishy gel body and a fuzzy cap, it’s perfect for fidgeting, squeezing, and stress relief. This unique mushroom design adds a fun twist to any collection and comes in vibrant colors that stand out on your desk or shelf. Whether you’re all about the squish or the fuzzy texture, this is a sensory must-have for all ages.\n\nBonus: FREE display when you order any 48 pieces of Super Duper Sugar Squishers product!\nAges 8+",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:40.505Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
